import { VALIDATION_REGEX_TIME } from "@/shared/lib/validation";
import { z } from "zod";

const negativeNumberError = "0以上の数字を入力してください";
const requiredErrorInput = { required_error: "入力してください" } as const;
const requiredErrorSelect = { required_error: "選択してください" } as const;

export const deliveryProposalDestinationDeadlineFormSchema = z.object({
  deadlineDate: z.string(requiredErrorInput).date().optional(),
  deadlineType: z
    .enum(["till", "just", "after", "earliest", "term"], requiredErrorSelect)
    .optional(),
  deadlineTime: z
    .string(requiredErrorInput)
    .regex(VALIDATION_REGEX_TIME)
    .optional(),
  deadlineTimeEnd: z
    .string(requiredErrorInput)
    .regex(VALIDATION_REGEX_TIME)
    .optional(),
});

export type DeliveryProposalDestinationDeadlineFormSchemaType = z.infer<
  typeof deliveryProposalDestinationDeadlineFormSchema
>;

export const createDeliveryProposalFormSchema = z.object({
  companyId: z.number(requiredErrorInput),
  vehicleId: z.number().optional(),
  shippingFee: z.number().min(0, negativeNumberError).optional(),
  memo: z.string().optional(),
  loadingDestination: deliveryProposalDestinationDeadlineFormSchema,
  transitDestinations: z.array(deliveryProposalDestinationDeadlineFormSchema),
  unloadingDestination: deliveryProposalDestinationDeadlineFormSchema,
});

export type CreateDeliveryProposalFormSchemaType = z.infer<
  typeof createDeliveryProposalFormSchema
>;
